import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace BarnHunt {
  export const form: IEventRegisterRow[] = [
    // Instinct (no sections)
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.barn_hunt_instinct,
          options: [
            { value: Constants.dog_class_element_level.barn_hunt_instinct, id: Constants.dog_class_element_level.barn_hunt_instinct }
          ]
        }
      ]
    },
    // Novice with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.barn_hunt_novice,
          options: [
            { value: Constants.dog_class_element_level.barn_hunt_novice, id: Constants.dog_class_element_level.barn_hunt_novice }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.barn_hunt_a, id: Constants.dog_class_section.barn_hunt_a },
            { value: Constants.dog_class_section.barn_hunt_b, id: Constants.dog_class_section.barn_hunt_b }
          ]
        }
      ]
    },
    // Open with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.barn_hunt_open,
          options: [
            { value: Constants.dog_class_element_level.barn_hunt_open, id: Constants.dog_class_element_level.barn_hunt_open }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.barn_hunt_a, id: Constants.dog_class_section.barn_hunt_a },
            { value: Constants.dog_class_section.barn_hunt_b, id: Constants.dog_class_section.barn_hunt_b }
          ]
        }
      ]
    },
    // Senior with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.barn_hunt_senior,
          options: [
            { value: Constants.dog_class_element_level.barn_hunt_senior, id: Constants.dog_class_element_level.barn_hunt_senior }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.barn_hunt_a, id: Constants.dog_class_section.barn_hunt_a },
            { value: Constants.dog_class_section.barn_hunt_b, id: Constants.dog_class_section.barn_hunt_b }
          ]
        }
      ]
    },
    // Master with Section dropdown
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.barn_hunt_master,
          options: [
            { value: Constants.dog_class_element_level.barn_hunt_master, id: Constants.dog_class_element_level.barn_hunt_master }
          ]
        },
        {
          type: "dropdown",
          label: "Section",
          options: [
            { value: Constants.dog_class_section.barn_hunt_a, id: Constants.dog_class_section.barn_hunt_a },
            { value: Constants.dog_class_section.barn_hunt_b, id: Constants.dog_class_section.barn_hunt_b }
          ]
        }
      ]
    },
    // Crazy 8s (no sections)
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.barn_hunt_crazy_8s,
          options: [
            { value: Constants.dog_class_element_level.barn_hunt_crazy_8s, id: Constants.dog_class_element_level.barn_hunt_crazy_8s }
          ]
        }
      ]
    },
    // Line Drive (no sections)
    {
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.dog_class_element_level.barn_hunt_line_drive,
          options: [
            { value: Constants.dog_class_element_level.barn_hunt_line_drive, id: Constants.dog_class_element_level.barn_hunt_line_drive }
          ]
        }
      ]
    }
  ];
}

